import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Briefcase, HardHat, ShieldCheck } from "lucide-react";
import { LegalFooter } from "@/components/LegalFooter";

export default function Login() {
  const navigate = useNavigate();

  // P1.1-Härtung: Die Rollen-Auswahl hat KEINEN Firmen-Kontext. Der
  // firmenbezogene Default-PIN-Hinweis erscheint daher nur auf dem
  // Unternehmer-Login (OwnerLogin) nach Eingabe des Firmen-Codes – hier kein
  // unscoped Abruf mehr (vermeidet Cross-Tenant-Info-Leak).
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col px-4 py-12">
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-5xl grid lg:grid-cols-2 gap-10 items-center">
        {/* Linke Seite: Markenversprechen */}
        <div className="space-y-8" data-testid="login-hero">
          <img
            src="/brand/clartext-logo-full-light.svg"
            alt="CLartext"
            className="h-16 sm:h-[72px] w-auto max-w-full object-contain"
            data-testid="app-logo-login"
          />
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-900 text-white text-xs font-medium">
            <ShieldCheck className="w-3.5 h-3.5" />
            Demo-Prototyp
          </div>
          <div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-slate-900 leading-[1.05] tracking-tight">
              Wenn die Prüfung kommt,
              <br />
              ist alles da.
            </h1>
            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-lg">
              Arbeitsschutz, Unterweisungen und Nachweise – automatisch für Ihr
              Unternehmen.
            </p>
          </div>
          <div className="flex items-center gap-6 text-sm text-slate-500 pt-2">
            <div>
              <span className="font-heading text-2xl font-bold text-slate-900 block">
                3 Min.
              </span>
              für eine Unterweisung
            </div>
            <div className="w-px h-10 bg-slate-200" />
            <div>
              <span className="font-heading text-2xl font-bold text-slate-900 block">
                0 Klicks
              </span>
              für den Nachweis
            </div>
          </div>
        </div>

        {/* Rechte Seite: Login-Karte */}
        <Card className="bg-white border border-slate-200 shadow-sm p-8 sm:p-10">
          <div className="mb-8">
            <p className="text-xs uppercase tracking-widest text-slate-500 font-medium">
              Anmelden als
            </p>
            <h2 className="font-heading text-2xl font-bold text-slate-900 mt-2">
              Wer bist du heute?
            </h2>
            <p className="text-sm text-slate-500 mt-2">
              Unternehmer-Demo ohne Anmeldung. Mitarbeiter melden sich mit ihrer
              persönlichen PIN an.
            </p>
          </div>

          <div className="space-y-3">
            <Button
              data-testid="login-unternehmer-button"
              onClick={() => navigate("/unternehmer/login")}
              className="w-full h-16 justify-between bg-slate-900 hover:bg-slate-800 text-white rounded-md text-base font-medium px-5"
            >
              <span className="flex items-center gap-3">
                <Briefcase className="w-5 h-5" />
                Als Unternehmer einloggen
              </span>
              <span className="text-xs text-slate-300 font-normal">
                Mit Master-PIN
              </span>
            </Button>

            <Button
              data-testid="login-monteur-button"
              onClick={() => navigate("/monteur/login")}
              variant="outline"
              className="w-full h-16 justify-between bg-white hover:bg-slate-50 text-slate-900 border border-slate-300 rounded-md text-base font-medium px-5"
            >
              <span className="flex items-center gap-3">
                <HardHat className="w-5 h-5" />
                Als Mitarbeiter anmelden
              </span>
              <span className="text-xs text-slate-500 font-normal">
                Mit PIN
              </span>
            </Button>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-100 text-xs text-slate-400">
            Mitarbeiter-PINs werden vom Unternehmer vergeben.
          </div>
        </Card>
        </div>
      </div>

      <div className="pt-8">
        <LegalFooter />
      </div>
    </div>
  );
}
